import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { doctorInfo, navigation } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Doctor Info */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              {doctorInfo.name}
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              {doctorInfo.title}
            </p>
            <p className="text-sm text-gray-500 italic">
              "{doctorInfo.tagline}"
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              Navigation
            </h4>
            <ul className="space-y-3">
              {navigation.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-sm text-gray-600 hover:text-teal-700 transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-teal-600 mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-600">{doctorInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-teal-600 flex-shrink-0" />
                <a
                  href={`tel:${doctorInfo.phone}`}
                  className="text-sm text-gray-600 hover:text-teal-700 transition-colors"
                >
                  {doctorInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-teal-600 flex-shrink-0" />
                <a
                  href={`mailto:${doctorInfo.email}`}
                  className="text-sm text-gray-600 hover:text-teal-700 transition-colors"
                >
                  {doctorInfo.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Clock className="w-4 h-4 text-teal-600 flex-shrink-0" />
                <span className="text-sm text-gray-600">{doctorInfo.hours}</span>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              Informations
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/mentions-legales"
                  className="text-sm text-gray-600 hover:text-teal-700 transition-colors"
                >
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link
                  to="/mentions-legales#ethique"
                  className="text-sm text-gray-600 hover:text-teal-700 transition-colors"
                >
                  Éthique et déontologie
                </Link>
              </li>
              <li>
                <Link
                  to="/mentions-legales#donnees"
                  className="text-sm text-gray-600 hover:text-teal-700 transition-colors"
                >
                  Protection des données
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500">
              © {currentYear} {doctorInfo.name}. Tous droits réservés.
            </p>
            <p className="text-xs text-gray-400">
              Les informations de ce site ne remplacent pas une consultation médicale.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
